import {
  GET_SEDES_REQUEST,
  GET_SEDES_SUCCESS,
  GET_SEDES_FAILURE,
} from '../../constants/sedes/sedes.constants';

export const getSedesAction = (page, start, limit) => ({
  type: GET_SEDES_REQUEST,
  payload: {
    page, start, limit,
  },
});

export const getSedesSuccessAction = (datos, total, page, start, limit) => ({
  type: GET_SEDES_SUCCESS,
  payload: {
    datos, total, page, start, limit,
  },
});

export const getSedesFailureAction = error => ({
  type: GET_SEDES_FAILURE,
  payload: error,
});
